import { FILMS } from '@/config/assets';

const BAND_IMAGES = [...FILMS, ...FILMS].map(f => f.image).filter(Boolean);

export default function CinematicBand() {
  return (
    <section data-testid="cinematic-band" className="py-6 overflow-hidden" style={{ background: 'var(--deep-black)' }}>
      <div className="cinematic-band">
        {BAND_IMAGES.map((img, i) => (
          <div key={i} className="flex-shrink-0 h-24 md:h-32 overflow-hidden" style={{ width: '200px', opacity: 0.6 }}>
            <img src={img} alt="" className="w-full h-full object-cover" loading="lazy" />
          </div>
        ))}
      </div>
    </section>
  );
}
